import React, {useContext} from 'react';
import {BridleContext} from '../BridleContextProvider';
import Buttons from '../components/Buttons';
import Page from '../components/Page';
import SectionInfo from '../components/SectionInfo';
import Toolbar from '../components/Toolbar';
import {getAttributesGroupedInDisplayOrder, getSortOrder, orderMap} from '../HelperFunctions';

const Reins = () => {
    const {products, options} = useContext(BridleContext);
    const pieces = getSortOrder(products, orderMap.Reins);
    const productId = options.Reins.productId;
    const attributesInOrder = getAttributesGroupedInDisplayOrder(pieces.attributeValues);

    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Reins" />
            <SectionInfo section="Reins" page="6" />
            <Page attributes={attributesInOrder} pageName="Reins" pieces={pieces} productId={productId} sizeGuide="" />
            <Buttons back="/noseband" next="/review" disableButton={productId === ''} />
        </div>
    );
};

export default Reins;
